/**
 * @fileoverview
 * User Model & Related Interfaces
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

export enum UserType {
  SUPER_ADMIN = 'SUPER_ADMIN',
  AUDITOR = 'AUDITOR',
  BRANCH_MANAGER = 'BRANCH_MANAGER',
  REGIONAL_MANAGER = 'REGIONAL_MANAGER',
  HO = 'HO',
  CUSTODIAN = 'CUSTODIAN',
  BRANCH = 'BRANCH',
}

export interface User {
  id: number;
  userName: string;
  email: string;
  firstName: string;
  lastName: string;
  userType: UserType;
  roleId: number;
  roleName?: string;
  active: boolean;
  lastLoginAt?: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface LoginRequest {
  identifier: string;
  password: string;
  /** @deprecated Use identifier — kept for backward compatibility with legacy clients */
  email?: string;
}

export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  csrfToken?: string;
  expiresIn: number;
  user: User;
}

export interface RefreshTokenRequest {
  refreshToken: string;
}

export interface RefreshTokenResponse {
  accessToken: string;
  expiresIn: number;
  csrfToken?: string;
}

export interface ForgotPasswordRequest {
  identifier: string;
  /** @deprecated Use identifier — kept for backward compatibility with legacy clients */
  email?: string;
}

export interface ResetPasswordRequest {
  token: string;
  newPassword: string;
}

export interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
}

export interface Permission {
  id: number;
  name: string;
  module: string;
  action: string;
  description?: string;
  isSubmodule?: boolean;
  parentModuleId?: number | null;
  submoduleName?: string | null;
  submodules?: Permission[];
}

